<template>
  <div>
    <div v-if="!isMobile" class="loginWrapper">
      <div>
        <div class="loginContainer">
          <div class="loginBox">
            <div class="loginBoxLogo">
              <div>
                <img
                  src="../../assets/statics/logo.png"
                  class="logo"
                  style="width: 140px; height: 28px"
                />
              </div>
            </div>
            <div class="loginFormWrapper">
              <VerifyCode />
            </div>
          </div>
        </div>
      </div>
      <ServicesButton />
    </div>
    <div v-else class="mobileLoginWrapper">
      <div class="headerWrapper">
        <div class="mobileTitle">CeMeta 小红书营销文案助手</div>
      </div>
      <div class="header">
        你好，
        <br />
        欢迎登录CeMeta
      </div>
      <div class="loginFormWrapper">
        <VerifyCode />
      </div>
    </div>
  </div>
</template>
<script>
import VerifyCode from "./VerifyCode.vue";
import ServicesButton from "./ServicesButton.vue";

export default {
  components: {
    VerifyCode,
    ServicesButton,
  },
  data() {
    return {
      isMobile: false,
    };
  },
  computed: {
    userName() {
      // {
      //     id: '',
      //     name: '',
      //     role: 0,
      //     token: ''
      // }
      return this.$store.state.user.name;
    },
  },
  methods: {
    accountOperate() {},
  },
  created() {
    this.isMobile = window.navigator.userAgent.includes("Mobile");
    _baq.track("page_view", { assets_id: "1772924118818887" });
  },
};
</script>
<style lang="less" scoped>
.loginWrapper {
  width: 100vw;
  height: 100vh;
  flex: 1;
  background-image: url("../../assets/statics/images/finalbackground.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;

  .loginContainer {
    width: 600px;
    height: 440px;
    z-index: 2;
    background-color: rgba(255, 255, 255, 0.5);
    border: 1px solid #fff;
    border-radius: 20px;
    flex-direction: row;
    display: flex;
    overflow: hidden;

    .loginImage {
      flex: 1;
      overflow: hidden;
      background: url("/statics/images/login2.png") content-box;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      background-color: var(--mtbird-primary-1);
    }
  }

  .loginFormWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 20px 20px 20px;
    flex-direction: column;
    margin-bottom: 10px;

    .loginTypeSwitch {
      margin-bottom: 30px;
      width: 100%;
      display: flex;

      :global {
        .ant-radio-button-wrapper {
          flex: 1;
          text-align: center;
        }
      }
    }
  }

  .loginBox {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .loginBoxLogo {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 32px;
      .logo {
        height: 80px;
        width: auto;
      }
    }

    .loginBoxForm {
      padding: 30px;
    }
  }
}

.mobileLoginWrapper {
  .headerWrapper {
    display: flex;
    justify-content: space-between;
    padding: 12px 20px;
  }

  .header {
    display: flex;
    background-image: url("../../assets/statics/login_bg.png");
    width: 100%;
    height: 234px;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 0 40px;
    align-items: center;
    font-size: 24px;
    font-weight: 500;
    line-height: 35px;
  }

  .loginFormWrapper {
    padding: 64px 40px;
    background-color: white;
    border-radius: 20px;
    margin-top: -20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue